import { ComponentProps } from "react";
import * as S from "./styles";

interface IRadioIconProps extends ComponentProps<"input"> {
  icon: string;
  label?: string;
}
export const RadioIcon = ({ icon, label, ...rest }: IRadioIconProps) => {
  return (
    <S.RadioIconWrapper>
      <img src={icon} alt="Icone de radio" />
      <S.RadioIconInput {...rest} type="radio" />
      {label && <span>{label}</span>}
    </S.RadioIconWrapper>
  );
};
